import React, {useEffect, useState} from "react";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from "@mui/material/Stack";
import services from "../../services";
import {Typography} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import {useLocation, useNavigate} from "react-router-dom";
import { Icon } from '@iconify/react';
import {RoutesList} from "../../Modules/RoutesList";
import {CurrentUser} from "../../pages/Users";


interface ViewUserDevices {
    userId : number
}

export const ViewUserDevices = ({id,uuid} : CurrentUser) =>{

    const navigate = useNavigate()

    const [devices,setDevices] = useState<any>([])

    const [showSkeleton,setShowSkeleton] = useState<boolean>(false)

    const [error,setError] = useState<string>('')

    const [showEmptyIcon,setShowEmptyIcon] = useState<boolean>(true)

    const viewDetails = (imei:string,category : string) =>{
        navigate(`/Dashboard/${imei}/details/${category}/${uuid}`)
    }

    useEffect(()=>{
        setShowSkeleton(true)
        setShowEmptyIcon(false)
        services.GetUserDevices({id:id,uuid:uuid})
            .then(res=>{
                if(res.data.length===0) {
                    setShowEmptyIcon(true)
                    setError('No device found')
                }
                setDevices(res.data)
                setShowSkeleton(false)
            })
            .catch(err=>{
                setShowSkeleton(false)
            })
    },[])

    return(
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 600 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Alias</TableCell>
                            <TableCell align="center">IMEI</TableCell>
                            <TableCell align="center">Category</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>


                        {
                            showSkeleton ?
                                [0,1,2].map(s=>(
                                    <TableRow
                                        key={s}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        {
                                            [0,1,2].map(n=>(
                                                <TableCell key={n} component="th" scope="row"><Skeleton animation={"wave"} height={20} /></TableCell>
                                            ))
                                        }

                                    </TableRow>
                                ))
                                :
                                devices.map((row:any,index:number) => (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 },
                                                cursor:'pointer',
                                                ":hover":{bgcolor:'#E7FAFF'},
                                            }}
                                            onClick={()=>viewDetails(row.deviceId,row.category)}
                                        >
                                            <TableCell align="center">{row.alias}</TableCell>
                                            <TableCell align="center">{row.deviceId}</TableCell>
                                            <TableCell align="center">{row.category}</TableCell>
                                        </TableRow>
                                    ))
                        }
                    </TableBody>
                </Table>
                {
                    showEmptyIcon?

                        <Box sx={{ width: '100%' }}>
                            <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                            >
                                <Icon icon="tabler:file-text" fontSize={50} color={'grey'} />
                                <span>No Records found</span>
                            </Stack>
                        </Box>
                        :''
                }
            </TableContainer>
    )
}